window.onload = function () {
  const leftBtn = document.querySelector("button.owl-prev");
  const rightBtn = document.querySelector("button.owl-next");

  leftBtn.setAttribute("aria-label", "Previous Slide");
  rightBtn.setAttribute("aria-label", "Next Slide");

  const slideBtns = document.querySelectorAll("button.owl-page");

  for (let i = 0; i < slideBtns.length; i++) {
    slideText = "Go to Slide " + (i+1)
    slideBtns[i].setAttribute("aria-label", slideText);
  }
}